"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Selectable = _interopRequireDefault(require("@commerce-ui/core2/Selectable"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _usePriceWithCurrency = _interopRequireDefault(require("@deosite/api/hooks/common/usePriceWithCurrency"));
var _LogoIcons = _interopRequireDefault(require("./LogoIcons"));
var _mainIcon = _interopRequireDefault(require("./LogoIcons/mainIcon"));
var __jsx = _react["default"].createElement;
var Pill = function Pill(props) {
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var translations = {
    forFree: (0, _langLibrary["default"])("Free delivery")
  };
  var pillClick = props.pillClick ? props.pillClick : function () {};
  return __jsx(_Selectable["default"], (0, _extends2["default"])({}, props, {
    sx: {
      pointerEvents: props.selected ? "none" : "unset"
    }
  }), function (_ref) {
    var _props$subtitleColor, _option$rightLabel;
    var disabled = _ref.disabled,
      selected = _ref.selected,
      label = _ref.label,
      invalid = _ref.invalid,
      subtitle = _ref.subtitle,
      option = _ref.option,
      addIcon = _ref.addIcon,
      largeIcon = _ref.largeIcon;
    return __jsx(_Box["default"], {
      sx: {
        position: "relative",
        borderStyle: "solid",
        borderWidth: invalid ? "1px" : 0,
        borderColor: disabled ? "neutral" : invalid && selected ? "negative" : "neutral",
        font: props.fontSet ? props.fontSet.body : "body2",
        color: "main",
        bg: disabled ? "neutral100" : "white",
        minHeight: "64px",
        display: "flex",
        justifyContent: "space-between",
        px: "14px",
        alignItems: "center",
        py: "s7"
      },
      onClick: function onClick() {
        return pillClick(props.option.methodCode);
      }
    }, __jsx(_Box["default"], {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, !disabled && __jsx(_Box["default"], {
      sx: {
        width: "24px",
        height: "24px",
        minWidth: "24px",
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "main",
        borderRadius: "30px",
        mr: "s7",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }
    }, selected && __jsx(_Box["default"], {
      as: "span",
      sx: {
        width: "16px",
        height: "16px",
        bg: "main",
        borderRadius: "30px",
        display: "inline-block"
      }
    })), __jsx(_Box["default"], {
      sx: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center"
      }
    }, __jsx(_Box["default"], {
      sx: {
        font: props.fontSet ? props.fontSet.bold : "s_sans_bold"
      }
    }, label), __jsx(_Box["default"], {
      sx: {
        font: props.fontSet ? props.fontSet.xs : "xs",
        color: (_props$subtitleColor = props.subtitleColor) !== null && _props$subtitleColor !== void 0 ? _props$subtitleColor : "beigeDarken",
        fontWeight: 700
      }
    }, subtitle), addIcon && __jsx(_LogoIcons["default"], {
      addIcon: addIcon,
      option: props.option,
      withMarginTop: option.price === 0,
      largeIcon: largeIcon
    }))), __jsx(_Box["default"], {
      sx: {
        textAlign: "right",
        alignSelf: [addIcon ? "flex-start" : "center", "center"],
        justifyContent: "flex-end"
      }
    }, option !== null && option !== void 0 && option.price ? priceWithCurrency(option.price) : option.price === 0 ? translations.forFree : (_option$rightLabel = option.rightLabel) !== null && _option$rightLabel !== void 0 ? _option$rightLabel : "", addIcon && __jsx(_mainIcon["default"], {
      type: props.option.id
    })));
  });
};
var _default = Pill;
exports["default"] = _default;